import Http from '../api/http/';

export default class FriendInvitation extends Http {
  constructor() {
    super();
  }
  /**
   * 查询邀新单据
   * @param {string} applicantname -  被推荐人姓名
   * @param {string} applicantphone -  被推荐人手机号
   * @param {integer} invitationtypes - 发放类型 1：用户注册 2：实名认证 3：首单任务 4：阶梯奖励 5：周排行奖励
   * @param {string} paytimeend - 支付结束时间 yyyy-mm-dd
   * @param {string} paytimestart - 支付开始时间 yyyy-mm-dd
   * @param {integer} paywaylist - 收款方式 0国外银行、1国内银行、2支付宝
   * @param {string} referrername - 被推荐人姓名
   * @param {string} referrerphone - 被推荐人号码
   * @param {string} userid - 用户id
   * @param {integer} rewardtype - 类型 1：积分，2：现金
   * @param {integer} rows - 行数
   * @param {integer} page - 页数
   * @param {array} statuslist - 状态 0未生成、1未生成（已驳回）、2未支付、3支付失败、4线上支付、5线下支付
   */
  friendInvitation_getInvitationReceiptsInfos() {
    return super.post('friendInvitation/getInvitationReceiptsInfos', ...arguments);
  }

  /**
   * 线下支付
   * @param {string} recommendTaskUserRewardId - recommendTaskUserRewardId
   * @param {string} reason - 原因
   */
  friendInvitation_offlinePay() {
    return super.post('friendInvitation/offlinePay', ...arguments);
  }

  /**
   * 查询邀新单据
   * @param {string} applicantname -  被推荐人姓名
   * @param {string} applicantphone -  被推荐人手机号
   * @param {integer} invitationtypes - 发放类型 1：用户注册 2：实名认证 3：首单任务 4：阶梯奖励 5：周排行奖励
   * @param {string} paytimeend - 支付结束时间 yyyy-mm-dd
   * @param {string} paytimestart - 支付开始时间 yyyy-mm-dd
   * @param {integer} paywaylist - 收款方式 0国外银行、1国内银行、2支付宝
   * @param {string} referrername - 被推荐人姓名
   * @param {string} referrerphone - 被推荐人号码
   * @param {string} userid - 用户id
   * @param {integer} rewardtype - 类型 1：积分，2：现金
   * @param {integer} rows - 行数
   * @param {integer} page - 页数
   * @param {array} statuslist - 状态 0未生成、1未生成（已驳回）、2未支付、3支付失败、4线上支付、5线下支付
   */
  friendInvitation_exportInvitationReceiptsInfos() {
    return super.post('friendInvitation/exportInvitationReceiptsInfos', ...arguments);
  }

  /**
   * 生成支付单据
   * @param {string} recommendTaskUserRewardIdList - recommendTaskUserRewardIdList
   */
  friendInvitation_addReceipts() {
    return super.post('friendInvitation/addReceipts', ...arguments);
  }

  /**
   * 查询好友邀请配置
   *
   */
  friendInvitation_getInvitationConfig() {
    return super.post('friendInvitation/getInvitationConfig', ...arguments);
  }

  /**
   * 好友邀请手机号黑名单列表 分页
   * @param {integer} rows - 行数
   * @param {integer} page - 页数
   * @param{string} phone - 手机号
   */
  friendInvitation_getInvoicePhoneInfos() {
    return super.post('friendInvitation/getInvoicePhoneInfos', ...arguments);
  }

  /**
   * 导入好友邀请手机号黑名单 分页
   * @param {file} excelFile - excelFile
   */
  friendInvitation_importBlackUserList() {
    return super.post('friendInvitation/importBlackUserList', ...arguments);
  }

  /**
   *  导入好友邀请手机号黑名单
   * @param {string} context - 提示语
   * @param {integer} maxNum - 每月阶梯奖励六的上限次数
   * @param {integer} status - 状态：0：下线，1：上线
   */
  friendInvitation_updateInvitationConfig() {
    return super.post('friendInvitation/updateInvitationConfig', ...arguments);
  }

  /**
   *  逻辑删除好友邀请手机号黑名单
   * @param {string} id - id
   */
  friendInvitation_deleteInvitationPhoneInfo() {
    return super.post('friendInvitation/deleteInvitationPhoneInfo', ...arguments);
  }

  /**
   *  终止支付
   * @param {string} recommendTaskUserRewardId - recommendTaskUserRewardId
   * @param {string} reasonb - reason
   */
  friendInvitation_noPay() {
    return super.post('friendInvitation/noPay', ...arguments);
  }

  /**
   *  无需支付详情接口
   */
  friendInvitation_getNoPayInfo() {
    return super.post('friendInvitation/getNoPayInfo', ...arguments);
  }
}
